import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useRaceApi } from '../services/api/useRace.api';
import { Case } from '../types/Case/Case.type';
import { Race } from '../types/Race.type';

const NON_CLIENT_RACE_ID = -6;

interface UseProcessedRacesOptions {
  caseData?: Case;
  includeComparisonRaces?: boolean;
}

export const useProcessedRaces = ({ caseData, includeComparisonRaces = true }: UseProcessedRacesOptions) => {
  const { getRaces } = useRaceApi();

  const {
    data: rawRaces,
    isLoading: isLoadingRaces,
    isError: isErrorRaces,
    error: racesError,
  } = useQuery<Race[]>({
    queryKey: ['races', includeComparisonRaces],
    queryFn: () => getRaces(includeComparisonRaces ? { comparison: includeComparisonRaces } : undefined),
    enabled: !!caseData,
  });

  const processedRaces = useMemo(() => {
    if (!rawRaces || !caseData || !caseData.client_race) {
      return [];
    }

    const clientRaceId = caseData.client_race.id;
    const clientRaceName = caseData.client_race.name;

    let filteredRaces = rawRaces.filter((r) => r.id !== clientRaceId);

    filteredRaces = filteredRaces.map((r) => {
      if (r.id === NON_CLIENT_RACE_ID) {
        return {
          ...r,
          name: `Non-${clientRaceName}`,
        };
      }
      return r;
    });

    return filteredRaces;
  }, [rawRaces, caseData]);

  return { processedRaces, isLoadingRaces, isErrorRaces, racesError };
};
